module.exports = __webpack_public_path__ + "img/delete.07f59e1a.svg";